const si = {
    actionAlready: "Še niste registrirani? Prijavite se",
    actionExit: "Odjava",
    actionLogin: "PRIJAVA",
    actionRegister: "REGISTRIRAJ SE",
    actionSave: "SHRANI",
    actionStart: "ZAČNI",
    actionContinue: "NADALJUJ",
    actionReset: "PONASTAVI OPRAVLJANJE",
    actionDoDiagnost: "POKAŽI DIAGNOSTIKO",
    actionYes: "Da",
    actionNo: "Ne",
    actionNext: "NAPREJ",
    actionBusinessCase: "POKAŽI DOBRE PRAKSE PODJETJA",
    actionBusinessCases: "POKAŽI DOBRE PRAKSE PODJETIJ",
    actionOpenUrl: "ODPRI URL",
    actionFilter: "FILTRIRAJ",

    /** HOME */
    msgHomeTitleOne: "Izmerite in povečajte raven krožne zrelosti vašega podjetja za pohištvo",
    msgHomeSubTitle: "Orodje FurnCIRCLE Online ocenjuje napredek vašega podjetja k krožni zrelosti na podlagi uporabljenih strategij kročnega oblikovanja",

    msgHomeSection2: "Pogoji krožnosti se širijo.</br>Ste pripravljeni?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Odgovorite na vprašanja o strategijah kročnega oblikovanja, ki jih trenutno uporablja vaše podjetje.</li><li>Pridobite indeks krožne zrelosti vašega podjetja.</li><li>Identificirajte strategije oblikovanja in dobre prakse podjetij za napredek vašega podjetja.</li><li>Učite se iz dobrih praks resničnih podjetij za nadaljnje izboljšanje ravni krožne zrelosti vašega podjetja.</li></ul>",
    msgHomeSection3: "Partnerji",
    msgHomeSection2Btn: "Začnite svojo oceno",
    msgHomeSection3Btn: "KONTAKT",

    /** HEADER */
    msgHeader1: "Strategije kročnega oblikovanja in dobre prakse",
    msgHeader4: "Prijava",

    /** DRAWER */
    msgCompany: "PODJETJE",
    msgDrawer1: "1. Odgovorite",
    msgDrawer2: "2. Ocenite",
    msgDrawer3: "3. Izboljšajte",
    msgDrawer4: "Zbirka strategij",
    msgDrawer6: "Nastavitve",
    msgDrawer7: "Odjava",

    /** LOGIN */
    msgWelcome: "Dobrodošli",
    msgWelcomeSubtitle: "Prosimo, prijavite se za nadaljevanje",

    /** REGISTER */
    msgGetStarted: "Začnite",
    msgGetStartedSubtitle: "To orodje za samooceno je brezplačno in zaupno",

    msgFirstname: "Ime",
    msgLastname: "Priimek",
    msgEmail: "E-pošta",
    msgPassword: "Geslo",
    msgConfirmPassword: "Potrdite geslo",
    msgCompanyUser: "Podjetje ali uporabniško ime",

    msgNotRegister: "Še niste registrirani? <b>Ustvarite račun tukaj</b>",
    msgAlreadyRegister: "Že registrirani? <b>Prijavite se tukaj</b>",

    /** HOME TOOL */
    msgClickImage: "Kliknite za širitev sistema linearnega proti krožnemu modelu.",

    msgArea: "OBMOČJE",
    msgProgress: "ODGOVORJENA VPRAŠANJA",

    msgAssessmentAreas: "Strategije kročnega oblikovanja in življenjski cikel izdelka",
    msgAssessmentDesc: "Strategije kročnega oblikovanja se uporabljajo med fazo oblikovanja in razvoja izdelkov, čeprav njihov (pozitiven) vpliv lahko nastopi v eni ali več poznejših fazah življenjskega cikla izdelka. Zato je en način za razvrstitev strategij kročnega oblikovanja glede na fazo življenjskega cikla, ki je vplivana: oblikovanje, materialni viri, proizvodnja, distribucija, uporaba in konec življenja.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Prosimo, odgovorite na vsa vprašanja za vsak blok ali fazo življenjskega cikla, določite svojo raven kročne zrelosti in načrtujte svoje izboljšanje ter prehod k bolj krožnemu gospodarstvu!</span>",

    msgAssessment: "FurnCIRCLE Ocena",
    msgNotApply: "Označite vse odgovore, ki veljajo za trenutno krožno uspešnost vašega podjetja. Odgovori se shranijo samodejno.",
    msgMarkImportant: "Označi kot pomembno",
    msgComment: "Komentar",
    msgCommentHolder: "Tukaj lahko napišete vse ustrezne informacije ali svoje komentarje.",

    /** ANSWER */
    msgPerformance: "Poročilo o oceni",
    msgPerformanceSubtitle: "Preverite indeks kročne zrelosti vašega podjetja in vsake faze življenjskega cikla vaših izdelkov.",
    msgCompanyLevel: "Indeks kročne zrelosti vašega podjetja (0%-100%)",
    msgBlockArea: "FAZA ŽIVLJENJSKEGA CIKLA",
    msgBlockValues: "VREDNOSTI",

    /** ASSESS */
    msgImprovement: "Poročilo o izboljšavah",
    msgImprovementMainSubtitle: "Učite se, kaj lahko storite za stalno izboljšanje kročnosti vašega podjetja. Spoznajte strategije oblikovanja in dobre prakse podjetij za napredek vašega podjetja.</br></br>Faze življenjskega cikla in strategije kročnega oblikovanja z rdečo oznako/krogom imajo raven uspešnosti enako ali manjšo od 25% njihove največje vrednosti, zato jih je treba obravnavati kot glavno prednost pri izboljšanju kročnosti podjetja. Faze ali strategije z oranžno oznako/krogom imajo raven uspešnosti višjo od 25% in manjšo ali enako 75%, zato je prav tako pomembno, da se ukvarjate z njihovo izboljšavo. Faze ali strategije z zeleno oznako/krogom imajo raven uspešnosti večjo od 75% in zato niso prednost pri izboljšavah.",
    msgImprovementSubtitle: "Učite se, kaj lahko storite za stalno izboljšanje kročnosti vašega podjetja. Spoznajte strategije oblikovanja in dobre prakse podjetij za napredek vašega podjetja.",
    msgLifecyclePhases: "Faze življenjskega cikla",
    msgLifecycleIndex: "Indeks kročnosti faze",
    msgActionsToImplement: "Dejanja za izvedbo:",
    msgBaselineScore: "Moj začetni rezultat",
    msgBusinessCaseEmpty: "Čestitamo! Že ste izvedli glavne strategije v tej kategoriji",

    msgCat1: "EKONOMSKI IN ORGANIZACIJSKI",
    msgCat2: "Družbeni",
    msgCat3: "OKOLJSKI",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Brskajte in raziskujte celotno zbirko strategij kročnega oblikovanja in dobrih praks podjetij projekta FurnCIRCLE.",
    msgLifecyclePhase: "Faza življenjskega cikla",
    msgDifficulty: "Težavnost izvedbe",
    msgBusinessDynamics: "Ustvarjanje ali dostava vrednosti",
    msgBusinessFactors: "Ponudba vrednosti / Stroški / Koristi",

    /** SETTINGS */
    msgUserInfo: "Uporabniške informacije",
    msgUserCredentials: "Uporabniški podatki",

    /** MODAL */
    msgAreSure: "Ste prepričani?",

    msgSuccess: "Posodobitev podatkov uspešna",
    msgDeleteSuccess: "Izbris podatkov uspešen",

    /** ALT TEXT */
    msgSaveCommentAlt: "Shrani “Komentar.” Ni treba shranjevati odgovorov na vprašanja; ti se shranijo samodejno.",
    msgDifficultyAlt: "Ta oznaka označuje težavnost izvajanja strategije krožnega oblikovanja.",
    msgBusinessBlockAlt: "Ta oznaka označuje, kateri poslovni blok modela CANVAS (Ustvarjanje Vrednosti ali Dostava Vrednosti) je prizadet z izvajanjem strategije krožnega oblikovanja.",
    msgImpactBlockAlt: "Ta oznaka označuje, kateri blok vpliva modela CANVAS (Stroški, Koristi ali Vrednostna Ponudba) je prizadet z izvajanjem strategije krožnega oblikovanja.",

    /** ERROR */
    errorOblData: "Izpolnite vsa obvezna polja",
    errorEmailFormat: "Napaka v formatu e-pošte",
    errorUserIncorrect: "E-pošta/geslo napačno",
    errorSend: "Napaka pri komunikaciji, prosim počakajte in poskusite kasneje",
    errorLength: "Preseženo število znakov",
    errorPassSame: "Gesli nista enaka",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Obnovitev gesla",
    msgRecoveryPasswordSubtitle: "Vnesite svoj e-poštni naslov, da prejmete kodo za ponastavitev gesla.",
    msgCode: "Koda",
    msgNewPassword: "Novo geslo",
    actionRequestCode: "ZAHTEVAJ KODO",
    actionUpdate: "POSODOBITEV",
    actionBack: "NAZAJ",
    msgForgetPassword: "Ste pozabili geslo?",
    errorRecovery: "Napaka pri obnovitvi gesla, preverite vnešeno kodo",

    /** FOOTER */
    msgFooterContact: "KONTAKT",

    msgFooterGr: "Financira Evropska unija. Mnenja in stališča so izključno stališča avtorja(jev) in ne odražajo nujno stališč Evropske unije. Evropska unija ali dodeljevalni organi ne odgovarjajo za njih. Referenca razpisa in pogodbe o dodelitvi: SOCPL-2022-SOC-DIALOG-01 (Projekt 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Vse pravice pridržane",

    msgFooterLegal: "Pravne opombe",
    msgFooterPrivacy: "Zasebnost",
    msgFooterCookies: "Politika piškotkov",

    /** PROGRESS VALUES */
    msgProgress0: "Strategije kročnega oblikovanja",

    /** COMPANY SIZES */
    msgCompanySize: "Wielkość firmy",
    msgCompanySize1: "Mniej niż 10 pracowników",
    msgCompanySize2: "10-30 pracowników",
    msgCompanySize3: "30-50 pracowników",
    msgCompanySize4: "Więcej niż 50 pracowników",

    /** PRODUCT TYPES */
    msgProductType: "Rodzaj produktów, które produkujesz",
    msgProductType1: "Tapicerka",
    msgProductType2: "Materace",
    msgProductType3: "Bazy tapicerskie, kanapy, ramy łóżek",
    msgProductType4: "Podwykonawca (ramy, obróbka, lakierowanie itp.)",
    msgProductType5: "Usługi (specjalistyczna logistyka itp.)",
    msgProductType6: "Meble z płyty (melamina, forniry, lakierowanie itp.)",
    msgProductType7: "Meble drewniane",
    msgProductType8: "Krzesła",
    msgProductType9: "Meble biurowe",
    msgProductType10: "Meble do przestrzeni publicznych i użytku",
    msgProductType11: "Drzwi, okna i wyroby stolarskie",
    msgProductType12: "Specjalistyczne wyposażenie (sklepy, biblioteki, restauracje, biznesy profesjonalne itp.)",
    msgProductType13: "Oświetlenie",
    msgProductType14: "Powłoki i podłogi",
    msgProductType15: "Tekstylia",
    msgProductType16: "Dekoracje",

    /* COUNTRIES */
    msgCountry: "Kraj",
    msgAfghanistan: "Afganistan",
    msgAlbania: "Albania",
    msgAlgeria: "Algieria",
    msgAmericanSamoa: "Amerykańska Samoa",
    msgAndorra: "Andora",
    msgAngola: "Angola",
    msgAnguilla: "Anguila",
    msgAntarctica: "Antarktyda",
    msgAntiguaandBarbuda: "Antigua i Barbuda",
    msgArgentina: "Argentyna",
    msgArmenia: "Armenia",
    msgAruba: "Aruba",
    msgAustralia: "Australia",
    msgAustria: "Austria",
    msgAzerbaijan: "Azerbejdżan",
    msgBahamas: "Bahamy",
    msgBahrain: "Bahrajn",
    msgBangladesh: "Bangladesz",
    msgBarbados: "Barbados",
    msgBelarus: "Białoruś",
    msgBelgium: "Belgia",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermudy",
    msgBhutan: "Bhutan",
    msgBolivia: "Boliwia",
    msgBosniaHerzegovina: "Bośnia i Hercegowina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Wyspa Bouvet",
    msgBrazil: "Brazylia",
    msgBritishIndian: "Terytorium Oceanu Indyjskiego Wielkiej Brytanii",
    msgBrunei: "Brunei",
    msgBulgaria: "Bułgaria",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Kambodża",
    msgCameroon: "Kamerun",
    msgCanada: "Kanada",
    msgCapeVerde: "Zielony Przylądek",
    msgCaymanIslands: "Wyspy Kajmanowe",
    msgCentralAfrican: "Republika Środkowoafrykańska",
    msgChad: "Czad",
    msgChile: "Chile",
    msgChina: "Chiny",
    msgChristmasIsland: "Wyspa Bożego Narodzenia",
    msgCocosIslands: "Wyspy Kokosowe (Keelinga)",
    msgColombia: "Kolumbia",
    msgComoros: "Komory",
    msgCongo: "Kongo",
    msgRepublicCongo: "Demokratyczna Republika Konga",
    msgCookIslands: "Wyspy Cooka",
    msgCostaRica: "Kostaryka",
    msgIvoryCoast: "Wybrzeże Kości Słoniowej",
    msgCroatia: "Chorwacja",
    msgCuba: "Kuba",
    msgCyprus: "Cypr",
    msgCzechRepublic: "Czechy",
    msgDenmark: "Dania",
    msgDjibouti: "Dżibuti",
    msgDominica: "Dominika",
    msgDominicanRepublic: "Republika Dominikany",
    msgEastTimor: "Timor Wschodni",
    msgEcuador: "Ekwador",
    msgEgypt: "Egipt",
    msgEngland: "Anglia",
    msgElSalvador: "Salwador",
    msgEquatorialGuinea: "Gwinea Równikowa",
    msgEritrea: "Erytrea",
    msgEstonia: "Estonia",
    msgEthiopia: "Etiopia",
    msgFalklandIslands: "Falklandy",
    msgFaroeIslands: "Wyspy Owcze",
    msgFijiIslands: "Wyspy Fidżi",
    msgFinland: "Finlandia",
    msgFrance: "Francja",
    msgFrenchGuiana: "Gujana Francuska",
    msgFrenchPolynesia: "Polinezja Francuska",
    msgFrenchSouthern: "Francuskie Terytoria Południowe",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Gruzja",
    msgGermany: "Niemcy",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grecja",
    msgGreenland: "Grenlandia",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Gwadelupa",
    msgGuam: "Guam",
    msgGuatemala: "Gwatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Gwinea",
    msgGuineaBissau: "Gwinea-Bisau",
    msgGuyana: "Gujana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Wyspy Heard i McDonalda",
    msgHolySee: "Stolica Apostolska (Watykan)",
    msgHonduras: "Honduras",
    msgHongKong: "Hongkong",
    msgHungary: "Węgry",
    msgIceland: "Islandia",
    msgIndia: "Indie",
    msgIndonesia: "Indonezja",
    msgIran: "Iran",
    msgIraq: "Irak",
    msgIreland: "Irlandia",
    msgIsrael: "Izrael",
    msgIsleMan: "Wyspa Man",
    msgItaly: "Włochy",
    msgJamaica: "Jamajka",
    msgJapan: "Japonia",
    msgJersey: "Jersey",
    msgJordan: "Jordania",
    msgKazakhstan: "Kazachstan",
    msgKenya: "Kenia",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuwejt",
    msgKyrgyzstan: "Kirgistan",
    msgLaos: "Laos",
    msgLatvia: "Łotwa",
    msgLebanon: "Liban",
    msgLesotho: "Lesotho",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Libijska Arabskiej Dżamahiriji",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Litwa",
    msgLuxembourg: "Luksemburg",
    msgMacao: "Makau",
    msgNorthMacedonia: "Północna Macedonia",
    msgMadagascar: "Madagaskar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malezja",
    msgMaldives: "Malediwy",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Wyspy Marshalla",
    msgMartinique: "Martynika",
    msgMauritania: "Mauretania",
    msgMauritius: "Mauritius",
    msgMayotte: "Majotta",
    msgMexico: "Meksyk",
    msgMicronesia: "Mikronezja, Stany Federacyjne",
    msgMoldova: "Mołdawia",
    msgMonaco: "Monako",
    msgMongolia: "Mongolia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Czarnogóra",
    msgMorocco: "Maroko",
    msgMozambique: "Mozambik",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Holandia",
    msgNetherlandsAntilles: "Antyle Holenderskie",
    msgNewCaledonia: "Nowa Kaledonia",
    msgNewZealand: "Nowa Zelandia",
    msgNicaragua: "Nikaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Wyspa Norfolk",
    msgNorthKorea: "Korea Północna",
    msgNorthernIreland: "Irlandia Północna",
    msgNorthernMariana: "Wyspy Mariany Północne",
    msgNorway: "Norwegia",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palestyna",
    msgPanama: "Panama",
    msgPapua: "Papua-Nowa Gwinea",
    msgParaguay: "Paragwaj",
    msgPeru: "Peru",
    msgPhilippines: "Filipiny",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polska",
    msgPortugal: "Portugalia",
    msgPuertoRico: "Portoryko",
    msgQatar: "Katar",
    msgReunion: "Reunion",
    msgRomania: "Rumunia",
    msgRussianFederation: "Federacja Rosyjska",
    msgRwanda: "Rwanda",
    msgSaintHelena: "Święta Helena",
    msgSaintKitts: "Saint Kitts i Nevis",
    msgSaintLucia: "Saint Lucia",
    msgSaintPierre: "Saint Pierre i Miquelon",
    msgSaintVincent: "Saint Vincent i Grenadyny",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Sao Tome i Principe",
    msgSaudiArabia: "Arabia Saudyjska",
    msgScotland: "Škotska",
    msgSenegal: "Senegal",
    msgSerbia: "Srbija",
    msgSeychelles: "Sejšeli",
    msgSierraLeone: "Sijera Leone",
    msgSingapore: "Singapur",
    msgSlovakia: "Slovaška",
    msgSlovenia: "Slovenija",
    msgSolomonIslands: "Solomonski otoki",
    msgSomalia: "Somalija",
    msgSouthAfrica: "Južna Afrika",
    msgSouthSandwich: "Južna Georgia in Južni Sandwichovi otoki",
    msgSouthKorea: "Južna Koreja",
    msgSouthSudan: "Južni Sudan",
    msgSpain: "Španija",
    msgSriLanka: "Šrilanka",
    msgSudan: "Sudan",
    msgSuriname: "Surinam",
    msgSvalbardJan: "Svalbard in Jan Mayen",
    msgSwaziland: "Svazi",
    msgSweden: "Švedska",
    msgSwitzerland: "Švica",
    msgSyria: "Sirija",
    msgTajikistan: "Tadžikistan",
    msgTanzania: "Tanzanija",
    msgThailand: "Tajska",
    msgTimorLeste: "Timor-Leste",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad in Tobago",
    msgTunisia: "Tunizija",
    msgTurkey: "Turčija",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Turki in Caicos otoki",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ukrajina",
    msgUnitedArabEmirates: "Združeni Arabski Emirati",
    msgUnitedKingdom: "Združeno kraljestvo",
    msgUnitedStates: "Združene države",
    msgUnitedStatesMinor: "Manjša zunanjo ozemlja Združenih držav",
    msgUruguay: "Urugvaj",
    msgUzbekistan: "Uzbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venecuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Britanski Deviški otoki",
    msgVirginIslandsUS: "Deviški otoki, ZDA",
    msgWales: "Wales",
    msgWallisFutuna: "Wallis in Futuna",
    msgWesternSahara: "Zahodna Sahara",
    msgYemen: "Jemen",
    msgZambia: "Zambija",
    msgZimbabwe: "Zimbabve",
}

export default si;